import React, {useState} from "react";
import {ClosableDialog} from "components/ClosableDialog";
import {CentredColumn} from "components/ClosableDialog.styles";
import {InlineAction} from "components/InlineAction.styles";
import {useMessages} from "i18n";
import {QrIcon} from "./icons";
import {shareLinkLabel} from "./shareLinkLabel";
import {QrTile} from "./shareLink";
import {ActionsRow, QrDialogLink} from "./ShareActionsRow.styles";

interface Props {
	url: string;
	/** The Play control, at the row's end, when this transfer offers a game. */
	play?: React.ReactNode;
}

/**
 * The row under the share link on both success cards (kitecorp/transferify-ui#3320, #3333): "Show QR code" at
 * its start and the game's Play control, when there is one, at its end. Both open in a dialog over the card,
 * never inline, so neither changes the card's height.
 */
export function ShareActionsRow({url, play}: Props) {
	const {sender} = useMessages();
	const [qrOpen, setQrOpen] = useState(false);
	return (
		<ActionsRow>
			<InlineAction type="button" aria-haspopup="dialog" onClick={() => setQrOpen(true)}>
				<QrIcon size={14}/>{sender.success.showQr}
			</InlineAction>
			{play}
			<ShareQrDialog url={url} open={qrOpen} onClose={() => setQrOpen(false)}/>
		</ActionsRow>
	);
}

/** The share link's QR in the app's dialog, with the link under it, as the transfer list's QR dialog shows one. */
function ShareQrDialog({url, open, onClose}: {url: string; open: boolean; onClose: () => void}) {
	const {transfers} = useMessages();
	return (
		<ClosableDialog title={transfers.dialog.qrTitle} open={open} onClose={onClose}>
			<CentredColumn>
				<QrTile url={url} size={160}/>
				<QrDialogLink>{shareLinkLabel(url)}</QrDialogLink>
			</CentredColumn>
		</ClosableDialog>
	);
}
